module.exports = __webpack_public_path__ + "media/mode_circulaire/planete-4c36a804.gif";